export default __webpack_public_path__ + "static/pattern-3@2x-b507f99c0978c315b55f7ffeec27bd23.png";